module.exports = __webpack_public_path__ + "9bcc07b2c693f607841ffd89de80f474.png";